var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIn2D(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0C8.95431 0 0 8.9543 0 20V40C0 51.0457 8.9543 60 20 60H40C51.0457 60 60 51.0457 60 40V20C60 8.95431 51.0457 0 40 0H20ZM21.7039 17.4353C20.4051 15.5216 16.9376 15.5216 15.6388 17.4353C14.7871 18.6902 14.7871 20.0231 15.6388 21.278C16.9376 23.1917 20.4051 23.1917 21.7039 21.278C22.5556 20.0231 22.5556 18.6902 21.7039 17.4353ZM21.8182 25.3357H15.4196V44.6364H21.8182V25.3357ZM25.3846 25.3357V44.6364H31.7832V32.993C31.7832 31.7343 33.1469 29.951 35.1923 29.951C37.2378 29.951 38.6014 31.7343 38.6014 32.993V44.6364H45V32.5734C45 28.4586 41.958 24.9169 37.7622 24.9161C33.4091 24.9152 31.7832 28.0629 31.7832 28.0629V25.3357H25.3846Z",
    fill: "url(#paint0_linear_972_36556)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_972_36556",
    x1: 30,
    y1: 0.282036,
    x2: 30,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#283474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#593C88"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn2D);
export default __webpack_public_path__ + "static/media/in2_d.61ac0ce6a02eb2a46cfdcaf180d58107.svg";
export { ForwardRef as ReactComponent };